export const BULK_COST_PRECISION  = 9

export const TASK_DESCRIPTION_MAX_LENGTH = 10240
export const TASK_NOTES_MAX_LENGTH = 2048
export const PURCHASE_ORDER_LABOR_MAX_LENGTH = 512
export const REFRESH_PERIOD = "30 seconds"
export const BATCH_NOTES_MAX_LENGTH = 2048
export const MAX_IMAGE_SIZE = (3*1024*1024)

export const CategoryType = {
    Wholesale: 0,
    Packaged: 2,
    Supplies: 3,
    Label: [
        'Bulk/Wholesale',
        'NOT USED',
        'Packaged',
        'Supplies'
    ]
}

export const StrainType = {
    Indica: 0,
    Sativa: 1,
    Hybrid: 2,
    Label: [
        'Indica',
        'Sativa',
        'Hybrid'
    ]
}

export const UnitType = {
    Each: 0,
    Gram: 1,
    MilliLiter: 2,
    Liter: 3,
    Lbs: 4,
    Fahrenheit: 5,
    Celsius: 6,
    Percent: 7,
    PPM: 8,
    hPa: 9,
    mScm: 10,
    Hour: 11,
    Label: [
        'Each',
        'g',
        'mL',
        'L',
        'lbs',
        'Fahrenheit',
        'Celsius',
        'Percent',
        'PPM',
        'hPa',
        'mS/cm',
        "Hours"
    ],
    SingularLabel: [
        'Each',
        'g',
        'mL',
        'L',
        'lb',
        'Fahrenheit',
        'Celsius',
        'Percent',
        'PPM',
        'hPa',
        'mS/cm',
        'Hour'
    ]
}

export const ProductType = {
    Flower: 0,
    PreRoll: 1,
    Beverage: 2,
    Wellness: 3,
    Extract: 4,
    InfusedPreroll: 5,
    InfusedFlower: 6,
    Vape: 7,
    Edible: 8,
    Clothing: 9,
    Supply: 10,
    Test: 11,
    Label: [
        "Flower",
        "PreRoll",
        "Beverage",
        "Wellness",
        "Extracts",
        "Infused Preroll",
        "Infused Flower",
        "Vape",
        "Edible",
        "Clothing/Appareal",
        "Supply",
        "Test"
    ]
}

export const ProductSubType = {
    "ZERO": 0,
    "ThreePointFiveGram": 1,
    "SevenGram": 2,
    "FourteenGram": 3,
    "TwentyEightGram" : 4,
    "LBs" : 5,
    "PointSevenFiveGram": 6,
    "PointFiveGram": 7,
    "TwoPointFiveGram": 8,
    "TenMilligram": 9,
    "TwentyFiveMilligram": 10,
    "HundredMilligram": 11,
    "OneGram": 12,
    "Bulk": 13,
    "Liters": 14,
    "TwoGram": 15,
    "XS": 16,
    "S": 17,
    "M": 18,
    "L": 19,
    "XL": 20,
    "XXL": 21,
    "XXXL": 22,
    "OnePointFiveGram": 23,
    "Container": 24,
    "Sticker": 25,
    "Miscellaneous": 26,
    "Test": 27,
    Label: [
        "ZERO",
        "3.5g",
        "7g",
        "14g",
        "28g",
        "LBs",
        ".75g",
        ".5g",
        "2.5g",
        "10mg",
        "25mg",
        "100mg",
        "1g",
        "Bulk",
        "Liters",
        "2g",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "XXL",
        "XXXL",
        "1.5g",
        "Container",
        "Sticker",
        "Miscellaneous",
        "Test"
    ]
}


export const InvoiceStatusType = {
    Created: 0,
    PaymentPending: 1,
    PartialPayment: 2,
    FullPayment: 3,
    Complete: 4,
    Label: [
        'Created',
        'Payment Pending',
        'Partially Paid',
        'Fully Paid',
        'Complete',
    ]
}

export const PurchaseOrderStatusType = {
    Created: 0,
    Fulfillment: 1,
    Complete: 2,
    Verified: 3,
    Label: [
        'Created',
        'Fulfillment',
        'Complete',
        'Verified'
    ]
}

export const PurchaseOrderItemStatusType = {
    Requested: 0,
    InProgress: 1,
    Complete: 2,
    Verified: 3,
    Label: [
        'Requested',
        'In-Progress',
        'Complete',
        'Verified'
    ]
}

export const BulkSizeType = {
    Bigs: 0,
    Smalls: 1,
    Clippings: 2,
    Label: [
        "Bigs",
        "Smalls",
        "Clipping"
    ]
}

export const PaymentStatusType = {
    Recorded: 0,
    Invalid: 3,
    Verified: 4,
    Label: [
        "Recorded",
        "", "",
        "Invalid",
        "Verified"
    ]
}

export const TaskStatusType = {
    Created: 0,
    Assigned: 1,
    InProgress: 2,
    Complete: 3,
    Verified: 4,
    Label: [
        "Created",
        "Assigned",
        "In-Progress",
        "Complete",
        "Verified"
    ]
}

export const TaskDueType = {
    None: 0,
    Soon: 1,
    Today: 2,
    OverDue: 3,
    Label: [
        "Not Due",
        "Soon",
        "Today",
        "Over Due"
    ]
}

export const BankTransactionType = {
    Payment: 0,
    Expense: 1,
    Transfer: 2,
    Invoice: 3,
    Return: 4,
    Label: [
        "Payment",
        "Expense",
        "Transfer",
        "Invoice",
        "Return"
    ]
}

export const MomEventType = {
    Create: 0,
    Clone: 1,
    Destroy: 2,
    DayHighTemperature: 3,
    DayLowTemperature: 4,
    NightHighTemperature: 5,
    NightLowTemperature: 6,
    DayHighHumidity: 7,
    DayLowHumidity: 8,
    NightHighHumidity: 9,
    NightLowHumidity: 10,
    LightPercentageTop: 11,
    LightPercentageUnderCanopy: 12,
    DayHighCO2: 13,
    DayLowCO2: 14,
    NightHighCO2: 15,
    NightLowCO2: 16,
    ECFeed: 17,
    PHFeed: 18,
    WaterTemperature: 19,
    Feed: 20,
    Transfer: 21,
    Harvest: 22,
    Label: [
        "Create",
        "Clone",
        "Destroy",
        "DayHighTemperature",
        "DayLowTemperature",
        "NightHighTemperature",
        "NightLowTemperature",
        "DayHighHumidity",
        "DayLowHumidity",
        "NightHighHumidity",
        "NightLowHumidity",
        "LightPercentageTop",
        "LightPercentageUnderCanopy",
        "DayHighCO2",
        "DayLowCO2",
        "NightHighCO2",
        "NightLowCO2",
        "ECFeed",
        "PHFeed",
        "WaterTemperature",
        "Feed",
        "Transfer",
        "Harvest",
    ]
}

export const InventoryAdjustmentType = {
    Add: 0,
    Subtract: 1,
    Set: 2
}

export const PlantRoomType = {
    Mom: 0,
    Clone: 1,
    Veg: 2,
    Flower: 3,
    Harvest: 4,
    Trim: 5,
    Destroyed: 6,
    Label: [
        "Mom",
        "Clone",
        "Veg",
        "Flower",
        "Harvest",
        "Trim",
        "Destroyed"
    ]
}

export const PlantStageType = PlantRoomType;

export const RoomMetricType = {
    Temperature: 0,
    Humidity: 1,
    CO2: 2,
    Feed: 3,
    VPD: 4,
    EC: 5,
    WC: 6,
    RootZoneTemperature: 7,
    Label: [
        "Temperature",
        "Humidity",
        "CO2",
        "Feed",
        "VPD",
        "EC",
        "WC",
        "Root Zone Temperature"
    ]
}

export const RowMetricType = {
    UpperLight: 0,
    LowerLight: 1,
    LowMoisture: 2,
    HighMoisture: 3,
    Label: [
        "UpperLight",
        "LowerLight",
        "LowMoisture",
        "HighMoisture"
    ]
}


export const getOptions = (x) => () => {
    let options = [];
    let labels = x["Label"];

    for (const v of Object.values(x)) {
        if (typeof v === "number") {
            const opt = {
                value: v,
                label: labels[v]
            }
            options.push(opt);
        }
    }

    return options;
}